import andraPradeshImg from "../images/afro-solar/large-projects/andra-pradsh.webp";
import jharkhandImg from "../images/afro-solar/large-projects/image80.webp";
import jindalImg from "../images/afro-solar/large-projects/jindal-plant.webp";
import mithaprImg from "../images/afro-solar/large-projects/mithapur-plant.webp";

const projects = [
  {
    img: andraPradeshImg,
    name: "100MW - Andhra Pradesh​​",
  },
  {
    img: mithaprImg,
    name: "17MW - Mithapur Plant​​​",
  },
  {
    img: jindalImg,
    name: "10MW – Jindal Plant​​​",
  },
  {
    img: jharkhandImg,
    name: "3MW - Jharkhand ​​​",
  },
];

const LargeProjectsExample = () => {
  return (
    <div className="pt-5 pb-7">
      <div className="container-fluid">
        <h1 className="fs-56 lh-64 text-center gilroy-bold pb-5">
          Large Projects
        </h1>
        <div className="ms-13 me-13">
          <div className="row align-items-center">
            {/* <div className="col-12 col-md-6 p-4">
              <h2 className="fs-56 gilroy-bold text-white">
                Examples of{" "}
                <span className="text-orange-ryb d-block">Large Projects:</span>
              </h2>
            </div> */}
            <div className="col-12 bg-white p-4 rounded">
              <div className="row g-4">
                {projects.map((project) => (
                  <div
                    key={project.name}
                    className="col-12 col-sm-6 col-md-6 pb-5"
                  >
                    <img
                      src={project.img}
                      alt={project.name}
                      className="img-fluid rounded w-100"
                    />
                    <h3 className="fs-18 gilroy-bold mt-3">{project.name}</h3>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LargeProjectsExample;
